<script>
/**
 * ****************************************************************************
 * @description     :   Progress Bar Component
 * @created at      :   2024/08/28
 * @created by      :   ANS891 – manhnd@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';
import { mapState } from 'vuex';

/**
 * Define content of panel component
 */
var AnsProgressBar = {
    template: template,
    props: {
        stepCurrent: Number,
        stepTotal: Number
    },
    data() {
        return {};
    },
    computed: {
        ...mapState('app', ['isShowLeftMenu']),
        numberStepDisable() {
            return this.stepTotal - this.stepCurrent;
        },
        isMobile() {
            return helpers.checkIfMobile();
        }
    },
    methods: {}
};
export default AnsProgressBar;
</script>
